enum EnumTypeList {
  line = 0,
  box = 1
}
export default EnumTypeList


// WEBPACK FOOTER //
// ./~/ui-components/~/list-view/src/EnumTypeList.ts